export const navSections = [
  { label: '今日实锤', anchor: '#flash' },
  { label: '专题合集', anchor: '#collections' },
  { label: '深扒脉络', anchor: '#timeline' },
  { label: '索引分区', anchor: '#index' },
  { label: '更新雷达', anchor: '#radar' },
  { label: '查证答疑', anchor: '#faq' },
];

export const heroStats = [
  { value: '340+', label: '已归档专题' },
  { value: '26', label: '持续深扒中' },
  { value: '86%', label: '细节追溯完整' },
  { value: '2026', label: '全年跟踪记录' },
];

export const flashList = [
  {
    rank: 1,
    tag: '进度更新',
    title: '一项证据复核完成，早期遗漏的细节被重新串上',
    time: '08:40',
    heat: '9.6万',
    status: 'HOT',
  },
  {
    rank: 2,
    tag: '线索新增',
    title: '旧案重提：一年前的线索如今与前情对上了',
    time: '11:05',
    heat: '7.2万',
    status: 'NEW',
  },
  {
    rank: 3,
    tag: '时段梳理',
    title: '多份时间节点交叉比对后，顺序已理清',
    time: '15:20',
    heat: '5.8万',
    status: '',
  },
  {
    rank: 4,
    tag: '查证备注',
    title: '相关细节仍在核验，暂不对结论下判断',
    time: '18:47',
    heat: '3.1万',
    status: '',
  },
  {
    rank: 5,
    tag: '补充来源',
    title: '新增两处可对照的资料，页码已标注',
    time: '21:12',
    heat: '1.9万',
    status: '',
  },
];

export const collections = [
  {
    code: '001',
    cover:
      'https://readdy.ai/api/search-image?query=close-up%20of%20a%20dark%20case%20file%20folder%20with%20a%20red%20CLASSIFIED%20stamp%20on%20aged%20paper%2C%20warm%20amber%20desk%20light%20and%20crimson%20redaction%20marks%2C%20noir%20investigative%20editorial%20photography%2C%20heavy%20film%20grain%2C%20high%20contrast%2C%20moody%20documentary%20composition%2C%20rich%20warm%20tones%20without%20blue%20or%20purple&width=720&height=480&seq=col-persona&orientation=landscape',
    group: '人物档案',
    title: '人物专题 · 持续归档',
    summary: '以人物为线索的专题档案，线索、回应与补充逐条收纳，便于来回对照。',
    items: '已收纳 41 个',
    count: 41,
  },
  {
    code: '002',
    cover:
      'https://readdy.ai/api/search-image?query=investigation%20evidence%20wall%20with%20printed%20pages%20pinned%20and%20connected%20by%20red%20string%2C%20warm%20grainy%20documentary%20light%2C%20crimson%20and%20gold%20tones%2C%20noir%20editorial%20photography%2C%20high%20contrast%20film%20grain%2C%20deep%20shadow%20and%20amber%20highlight%2C%20mysterious%20investigative%20atmosphere&width=720&height=480&seq=col-slot&orientation=landscape',
    group: '时段特辑',
    title: '时段特辑 · 集中复盘',
    summary: '把同一时间窗口内的事情集中回放，排序、间隔与关联都尽量还原。',
    items: '共 17 辑',
    count: 17,
  },
  {
    code: '003',
    cover:
      'https://readdy.ai/api/search-image?query=magnifying%20glass%20resting%20on%20vintage%20newspaper%20pages%20with%20underlined%20lines%20and%20red%20notes%2C%20warm%20lamplight%20scene%2C%20crimson%20and%20amber%20tones%2C%20noir%20investigative%20editorial%20photography%2C%20film%20grain%2C%20high%20contrast%2C%20focused%20detail%20shot%2C%20moody%20warm%20documentary%20atmosphere&width=720&height=480&seq=col-cold&orientation=landscape',
    group: '冷门猛料',
    title: '冷门细料 · 少人注意',
    summary: '藏在角落里的零碎细节，整理成便于顺藤摸瓜的索引。',
    items: '共 23 条',
    count: 23,
  },
  {
    code: '004',
    cover:
      'https://readdy.ai/api/search-image?query=old%20cassette%20recorder%20and%20microphone%20on%20a%20dark%20desk%20at%20night%2C%20small%20amber%20recording%20light%2C%20noir%20investigative%20editorial%20photography%2C%20crimson%20and%20gold%20tones%2C%20film%20grain%2C%20high%20contrast%2C%20moody%20documentary%20composition%2C%20warm%20shadowy%20atmosphere&width=720&height=480&seq=col-boil&orientation=landscape',
    group: '发酵现场',
    title: '发酵现场 · 实时风向',
    summary: '事件发酵过程中的讨论走向与关注起伏，标注关键转折点。',
    items: '共 9 场',
    count: 9,
  },
  {
    code: '005',
    cover:
      'https://readdy.ai/api/search-image?query=paper%20envelopes%20and%20loose%20photographs%20spread%20on%20a%20dark%20table%2C%20some%20marked%20with%20red%20circles%2C%20warm%20amber%20lighting%2C%20noir%20investigative%20editorial%20photography%2C%20crimson%20and%20gold%20tones%2C%20film%20grain%2C%20high%20contrast%2C%20cluttered%20moody%20documentary%20scene&width=720&height=480&seq=col-evi&orientation=landscape',
    group: '证据整理',
    title: '证据整理 · 逐页归档',
    summary: '原始资料按页归档、标注页码与日期，方便查证时逐条回溯。',
    items: '共 12 卷',
    count: 12,
  },
  {
    code: '006',
    cover:
      'https://readdy.ai/api/search-image?query=rain%20streaking%20across%20a%20dim%20night%20street%20with%20reflecting%20warm%20lamplight%2C%20no%20people%2C%20noir%20editorial%20photography%2C%20crimson%20and%20amber%20tones%2C%20film%20grain%2C%20high%20contrast%2C%20melancholy%20documentary%20atmosphere%2C%20deep%20shadow%20and%20warm%20glow&width=720&height=480&seq=col-follow&orientation=landscape',
    group: '后续跟进',
    title: '后续跟进 · 未完待续',
    summary: '已公开但尚未尘埃落定的专题，保留旧进度并持续补充新进展。',
    items: '共 14 篇',
    count: 14,
  },
];

export const timeline = [
  {
    step: '第 1 步',
    time: '线索汇聚期',
    title: '多源线索开始交叉',
    detail: '把零散线索按时间先后排布，先画出大致的顺序骨架。',
  },
  {
    step: '第 2 步',
    time: '细节核验期',
    title: '逐条核对前后顺序',
    detail: '对涉及顺序的细节反复比对，避免把先后关系弄混。',
  },
  {
    step: '第 3 步',
    time: '脉络成型期',
    title: '整理成完整深扒',
    detail: '按先后把细节串成完整脉络，标注出处与待补项。',
  },
  {
    step: '第 4 步',
    time: '持续跟进期',
    title: '新进展随时补录',
    detail: '后续有新的对应细节会直接在对应专题下继续追加。',
  },
];

export const deepIntro = {
  title: '深度专题 · 细节深扒进行中',
  text: '把「九色黑料」相关的事件按先后顺序一点点理开，从时间线、资料出处到前后因果逐条对位，方便想查证的人按顺序找到对应细节，少走弯路。',
};

export const indexGroups = [
  {
    name: '按人物',
    desc: '想锁定某一个对象，从这里进',
    tags: ['焦点人物专题', '关联人物补充', '人物前后回应', '旧档案重提'],
  },
  {
    name: '按时段',
    desc: '想回到某个时间窗口，从这里进',
    tags: ['2026 实时专题', '年度复盘特辑', '早期遗留线索', '跨月串联整理'],
  },
  {
    name: '按题材',
    desc: '想看某一类细节，从这里进',
    tags: ['时间线复原', '资料对照', '现场还原', '疑点与待证'],
  },
  {
    name: '按进度',
    desc: '想知道进行到哪一步，从这里进',
    tags: ['深扒进行中', '细节核验中', '线索待补充', '尘埃已落定'],
  },
];

export const radarList = [
  { label: '人物档案 041', ratio: 82, phase: '脉络成型', date: '09-03' },
  { label: '时段特辑 017', ratio: 66, phase: '细节核验', date: '09-05' },
  { label: '后续跟进 · 冷料补充', ratio: 48, phase: '线索汇聚', date: '09-06' },
  { label: '现场还原 · 待核验', ratio: 31, phase: '资料比对', date: '待定' },
];

export const updateNote = '排序以事件先后为准，交叉的部分单独标注，方便读者逐段对照。';

export const faqs = [
  {
    q: '这里的内容按什么顺序排列？',
    a: '默认以事件发生的先后顺序排布；同一时间点内发生的事情会拆开标注先后，方便想按顺序查证的人逐段对照。',
  },
  {
    q: '想找某个特定细节，应该从哪里开始？',
    a: '建议先到「索引分区」按人物 / 时段 / 题材 / 进度四路定位，再进入对应专题合集看大图封面下的简介，必要时跳进「深扒脉络」看整段顺序。',
  },
  {
    q: '内容会实时更新吗？',
    a: '会的。凡是出现新的对应细节，都会在原有专题下直接追加进度，并在「今日实锤」「更新雷达」同步提示，不会另起炉灶让你重找。',
  },
  {
    q: '尚未核实的部分如何处理？',
    a: '所有没跑通前后顺序、或来源待补的细节都会明确标注为「核验中 / 待补充」，不会混进已理顺的段落，避免误导。',
  },
];

export const footerLinks = [
  { name: '专题合集', anchor: '#collections' },
  { name: '深扒脉络', anchor: '#timeline' },
  { name: '索引分区', anchor: '#index' },
  { name: '更新雷达', anchor: '#radar' },
  { name: '查证答疑', anchor: '#faq' },
];

export const footerNote =
  '本页仅对公开可查的内容做归档与顺序梳理，供想查证九色黑料实锤、内幕与细节的人参考；标注为「核验中 / 待补充」的内容不代表最终结论，请结合原始资料独立判断。';